<template>
    <div class="h-panel">
        <div class="barHeard">
            {{this.idVal ? '编辑消息':'添加消息'}}
        </div>
        <div class="h-panel-form">
            <Form :label-width="110" :mode="columns" :model="entity" ref="form" :rules="validRules" v-width="500">
                <FormItem label="会员id" prop="entity.memberId"><input type="text" v-model="entity.memberId"/></FormItem>
                <FormItem label="消息内容" prop="entity.messageContent"><input type="text" v-model="entity.messageContent"/></FormItem>
                <FormItem label="消息id" prop="entity.messageId"><input type="text" v-model="entity.messageId"/></FormItem>
                <FormItem label="事件名字" prop="entity.incidentName"><input type="text" v-model="entity.incidentName"/></FormItem>
                <FormItem label="状态" prop="entity.status"><input type="text" v-model="entity.status"/></FormItem>
                <FormItem label="创建时间" prop="entity.createAt"><input type="text" v-model="entity.createAt"/></FormItem>
                <FormItem label="是否读取" prop="entity.read"><input type="text" v-model="entity.read"/></FormItem>
            </Form>
            <div style="text-align: center">
                <Button color="primary" style="width: 150px" @click="submit()">提交</Button>
                <Button color="red" style="margin-left:20px;width: 150px" @click="close">关闭</Button>
            </div>
        </div>
    </div>
</template>

<script>
export default {
  props: ['idVal'],
  data() {
    return {
      entity: {
        id: this.idVal,
        memberId: null,
        instationContent: null,
        messageContent: null,
        createAt: null
      },
      validRules: {
        // required: ['memberId','instationContent','messageContent','createAt'],
        required: [],
        tel: [],
        int: [],
        number: [],
        url: [],
        email: [],
        mobile: [],
        rules: {}
      },
      columns: 'twocolumn'// single,twocolumn,threecolumn
    };
  },
  mounted() {
    if (this.idVal) { this.findById(); }
  },
  methods: {
    save() {
      this.$Loading('保存中，请稍后');
      httpKit.post($api_pms.message.save, this.entity).then(res => {
        this.$Loading.close();
        if (res.data.code === '200') {
          this.$Message.success(res.data.msg);
          this.closeAndRefreshParent();
        } else {
          this.$Message.error(res.data.msg);
        }
      });
    },
    submit() {
      if (this.$refs.form.valid().result) { this.save(); }
    },
    findById() {
      httpKit.post($api_pms.message.info, { id: this.idVal }).then(res => {
        if (res.data.code === '200') {
          this.entity = res.data.data;
        } else {
          this.$Message.error(res.data.msg);
        }
      });
    },
    closeAndRefreshParent() { this.$emit('refresh'); },
    close() { this.$emit('close'); }
  }
};
</script>

<style lang="less">

</style>
